import MuiList from "@mui/material/List";
import MuiListItem from "@mui/material/ListItem";


List.Item = MuiListItem;

export default function List(props) {
	return <MuiList {...props}/>;
}